import { FC, useMemo, useContext, PropsWithChildren } from 'react';
import useCoordinatingGroups from '@/hooks/data/useCoordinatingGroups';
import CoordinatingGroupContext, { ICoordinatingGroupContext } from '@/contexts/data/CoordinatingGroupContext';
import IsLoading from '@/components/layouts/IsLoading';
import { useMatch, useParams } from 'react-router-dom';
import CoordinatingGroupsContext from '@/contexts/data/CoordinatingGroupsContext';
import InstitutionContext from '@/contexts/data/InstitutionContext';


export interface ICoordinatingGroupProviderProps {
}

export const CoordinatingGroupProvider: FC<PropsWithChildren<ICoordinatingGroupProviderProps>> = ({ children }) => {
    const coordinatingGroups = useContext(CoordinatingGroupsContext);
    const institution = useContext(InstitutionContext);

    const coordinatingGroupId = institution.data?.coordinatingGroupId;
    const coordinatingGroupCode = useParams()?.coordinatingGroupCode;

    const coordinatingGroup  = useMemo(() => {
        if (!coordinatingGroupId && !coordinatingGroupCode) {
            return {
                data: undefined,
                error: undefined,
                loading: false,
                validating: false,
                refresh: async () => {
                    return undefined;
                },
            } as ICoordinatingGroupContext;
        }

        if (!!coordinatingGroupCode) {
            return {
                data: coordinatingGroups.data?.find(x => x.code === coordinatingGroupCode),
                error: coordinatingGroups.error,
                loading: coordinatingGroups.loading,
                validating: coordinatingGroups.validating,
                refresh: async () => {
                    const newData = await coordinatingGroups.refresh();
    
                    return newData?.find(x => x.code === coordinatingGroupCode);
                },
            } as ICoordinatingGroupContext
        }

        return {
            data: coordinatingGroups.data?.find(x => x.id === coordinatingGroupId),
            error: coordinatingGroups.error,
            loading: coordinatingGroups.loading,
            validating: coordinatingGroups.validating,
            refresh: async () => {
                const newData = await coordinatingGroups.refresh();

                return newData?.find(x => x.id === coordinatingGroupId);
            },
        } as ICoordinatingGroupContext
    }, [coordinatingGroups, coordinatingGroupId, coordinatingGroupCode]);

    return (

        <CoordinatingGroupContext.Provider value={coordinatingGroup}>
            <IsLoading name="coordinating-group" loading={coordinatingGroup.loading} validating={coordinatingGroup.validating}/>
            {children}
        </CoordinatingGroupContext.Provider>
    );
}

export default CoordinatingGroupProvider;
